export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9869.651e6fd6.jpg";